import EditProfileWizardModal from './EditProfileWizardModal';

export default EditProfileWizardModal;
